import { Check } from 'lucide-react';

export interface HeroConfig {
  siteName: string;
  heroTitle: string;
  heroSubtitle: string;
  heroFeature1: string;
  heroFeature2: string;
  heroFeature3: string;
}

interface HeroSectionProps {
  config: HeroConfig;
}

export function HeroSection({ config }: HeroSectionProps) {
  return (
    <div className="text-center py-12 px-4">
      <h1 className="text-4xl md:text-5xl font-bold text-light-text mb-4 tracking-tight">
        {config.siteName} - {config.heroTitle}
      </h1>
      <p className="text-light-muted mb-6 text-lg">
        {config.heroSubtitle}
      </p>
      <div className="flex items-center justify-center gap-6 text-sm text-light-muted">
        <span className="flex items-center gap-2">
          <Check className="w-4 h-4 text-accent-green" />
          {config.heroFeature1}
        </span>
        <span className="flex items-center gap-2">
          <Check className="w-4 h-4 text-accent-green" />
          {config.heroFeature2}
        </span>
        <span className="flex items-center gap-2">
          <Check className="w-4 h-4 text-accent-green" />
          {config.heroFeature3}
        </span>
      </div>
    </div>
  );
}
